(function () {
  window.smsBumpSubscribe ||= function (phone, email, source, acceptsMarketing = true, emailConsent = true) {
    var smsbump_request = {
      form_id: 359570,
      phone: phone.trim(),
      email,
      accepts_marketing: acceptsMarketing,
      email_consent: emailConsent,
      source,
    };

    if (source) {
      smsbump_request.source = source;
    }

    if (smsbump_request.phone.length) {
      var smsbXhr = new XMLHttpRequest();
      smsbXhr.open('POST', 'https://api.smsbump.com/v2/formsPublic/subscribe');
      smsbXhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      smsbXhr.setRequestHeader('X-SMSBump-Platform', 'shopify');
      smsbXhr.onload = function () {
        if (smsbXhr.status === 200) {
          console.log('smsbump subscribe')
          let formField = document.querySelector('[class*="footer-newsletter-row"]');
          formField.style.display = 'none';
          formField.insertAdjacentHTML('afterend', '<span>Thank you for subscribing!</span>')

        } else if (smsbXhr.status !== 200) {
          console.log('smsbump error')
        }
      };
      var query = encodeURI('form_id=' + smsbump_request.form_id + '&phone=' + smsbump_request.phone + '&accepts_marketing=' + smsbump_request.accepts_marketing + '&email=' + smsbump_request.email + '&email_consent=' + smsbump_request.email_consent);

      if (smsbump_request.source) {
        query += '&source=' + smsbump_request.source
      }

      smsbXhr.send(query);
    }
  };
  document.querySelector('.footer-newsletter-form [type="submit"]').addEventListener('click', (e) => {
    e.preventDefault();
    let email = document.querySelector('.footer-newsletter-form [type="email"]').value
    if (!email) return;

    smsBumpSubscribe('555-555-5555', email, 'Dev Test');

  })
}());